<div  class="flex-row flex-fill" >
    <mat-form-field
        [appearance]="to.appearance"
        [color]="to.color"
        [floatLabel]="to.floatLabel"
        class="flex-auto"
        [hideRequiredMarker]="true"
    >
        <ng-container #fieldComponent></ng-container>
    </mat-form-field>
    <button
        aria-label="Clear"
        [disabled]="empty"
        mat-icon-button
        matSuffix
        (click)="clearValue()"
    >
        <mat-icon>close</mat-icon>
    </button>
</div>
